import { CheckCircle } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function UploadImageButton({ handleChange, title, name, maxSize, accept = "image/*", onError, ...props }) { //onUploadStart, onUploadEnded,
    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onloadend = () => {
                setIsSuccess(true)
            }
            reader.onerror = reject;
            reader.readAsDataURL(file);
        })
    }

    const fileReadHandler = async (e) => {
        try {
            // onUploadStart()
            setLoading(true)
            let files = e.target.files

            if (files?.length) {

                let currentFile = files[0]

                if (!!maxSize) {
                    const fileSizeInMB = currentFile.size / 1024 / 1024;
                    if (fileSizeInMB > maxSize) {
                        !!onError && onError(t("fileMaxSize", { maxSize }))
                        return
                    }
                }

                let acceptFileTypes = accept.replace('image/*', 'png,bmp,webp,tiff,svg,icon,jpeg,jpg').replace(/image\//g, '').replace(/application\//g, '').replace(/.\//g, '');
                let type = currentFile.type.split('/')[1];


                if (!(accept.includes("image/*") && currentFile.type.includes("image/")) && !acceptFileTypes.includes(type)) {
                    !!onError && onError(t("invalidFileTypeUpload", { acceptFileTypes }));
                    return;
                }

                let base64 = await readFileAsync(currentFile)
                handleChange({ target: { name, value: base64 } })
            }
        } catch (error) {
            console.log("error")
            console.log(error)
        } finally {
            // onUploadEnded()
            setLoading(false)
        }
    }

    return (
        <LoadingButton
            loading={loading}
            endIcon={isSuccess && <CheckCircle color="success" />}
            component="label"
            {...props}
        >
            {title}
            <input
                hidden name={name}
                accept={accept}
                multiple
                type="file"
                onChange={fileReadHandler}
            />
        </LoadingButton>
    )
}